const BOLD = /\*\*([\s\S]+?)\*\*/;
const LINK = /!\[([^\]]*)\]\(([^)]*)\)/;
const ESCAPE = /\\(\*)/;

function firstMatch(rest) {
    const candidates = [
        { kind: "escape", match: ESCAPE.exec(rest) },
        { kind: "link", match: LINK.exec(rest) },
        { kind: "bold", match: BOLD.exec(rest) }
    ].filter(candidate => candidate.match !== null);

    if (candidates.length === 0) return null;

    return candidates.reduce((earliest, candidate) =>
        candidate.match.index < earliest.match.index ? candidate : earliest);
}

export function parseInline(value) {
    if (typeof value !== "string" || value === "") return [];

    const nodes = [];
    let rest = value;

    while (rest.length > 0) {
        const next = firstMatch(rest);
        if (!next) {
            nodes.push({ type: "text", value: rest });
            break;
        }

        const { kind, match } = next;
        if (match.index > 0) {
            nodes.push({ type: "text", value: rest.slice(0, match.index) });
        }

        if (kind === "escape") {
            nodes.push({ type: "text", value: match[1] });
        } else if (kind === "link") {
            nodes.push({ type: "link", href: match[1], children: parseInline(match[2]) });
        } else {
            nodes.push({ type: "bold", children: parseInline(match[1]) });
        }

        rest = rest.slice(match.index + match[0].length);
    }

    return nodes;
}
